import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderProvinces,
} from "store/provider-dashboard/provider-dashboard-action"
import {
  exportProviderQuantificationReport,
  exportProviderQuantificationReportBasedOrganization,
  getProviderQuantificationReportBasedOrganization,
} from "store/provider-reports/p-report-action"
import ProviderQuantificationOrganizationReportListComponent from "components/ProviderReports/QuantificationBasedOrganization"
import { getProviderConsumptionsProjects } from "store/provider-consumption/province-consumption-action"

const ProviderQuantificationOrganizationReport = () => {
  //meta title
  document.title = "Quantification Based Organization Report"

  const [params, setParams] = useState({})
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.providerReports.providerQuantificationReport.data,
    error: state.providerReports.providerQuantificationReport.error,
    loading: state.providerReports.providerQuantificationReport.loading,
    exportStatus: state.providerReports.providerQuantificationExport,
  }))

  const dispatch = useDispatch()
  const { columns, visibleColumns, visibleKeys, toggleColumn } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_QUANTIFICATION_ORG
  )

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(getProviderQuantificationReportBasedOrganization(link.url, params))
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setParams(prev => {
      return { ...prev, pageNumber: value }
    })
    dispatch(
      getProviderQuantificationReportBasedOrganization(undefined, {
        ...params,
        pageNumber: value,
      })
    )
  }

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportProviderQuantificationReportBasedOrganization(params, visibleKeys))
  }

  // fetch quantification based organization and other data which is needs filter
  useEffect(() => {
    dispatch(getProviderQuantificationReportBasedOrganization())
    dispatch(getProviderConsumptionsProjects())
    dispatch(getProviderIps())
    dispatch(getProviderProvinces())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = filter => {
    setParams(filter)
    dispatch(
      getProviderQuantificationReportBasedOrganization(undefined, filter)
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"Quantification Based Organization Report"}
      />
      {/* Provider Quantification base organization list component  */}
      <ProviderQuantificationOrganizationReportListComponent
        data={data}
        error={error}
        loading={loading}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExport}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
      />
    </React.Fragment>
  )
}

export default ProviderQuantificationOrganizationReport
